<template>
  <div class="base-info">
    <a-card title="角色权限" :bordered="false" :headStyle="{paddingLeft:'0px'}">
    </a-card>
    <a-button type="primary" style="margin-top: 20px;margin-bottom: 20px" @click="addRoleEvent">
      + 添加角色
    </a-button>
    <custom-page-table
      ref="table"
      rowKey="roleId"
      :columns="columns"
      :requestPromise="getRequestPromise">
      <span slot="dataPermission" slot-scope="rowItem">{{ rowItem.text|dataPermissionsName }}</span>
      <span slot="action" slot-scope="rowItem">
        <a @click="editRoleEvent(rowItem.record)">修改</a>
        <a-divider type="vertical"></a-divider>
        <a-popconfirm
          title="是否要删除当前角色？"
          @confirm="deleteEvent(rowItem.record)">
                 <a>删除</a>
        </a-popconfirm>
      </span>
    </custom-page-table>
  </div>

</template>

<script>

export default {
  name: 'RolePermissionsComponents',
  data() {
    return {
      columns: [
        {
          title: 'ID',
          dataIndex: 'roleId'
        },
        {
          title: '角色名称',
          dataIndex: 'roleName'
        },
        {
          title: '账号数',
          dataIndex: 'accountNum'
        },
        {
          title: '数据权限',
          dataIndex: 'dataPermission',
          scopedSlots: { customRender: 'dataPermission' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
  },
  activated() {
    this.$refs.table.refresh(true)
  },
  methods: {
    getRequestPromise(params) {
      return this.getHttpServices().getPermissionService().post('permission/v2/getRolePage', params)
    },
    addRoleEvent() {
      this.openNewPage('RoleCreator', {})
    },
    editRoleEvent(record) {
      this.openNewPage('RoleEditor', {
        roleId: record.roleId,
        roleName: record.roleName,
        dataPermission: record.dataPermission
      })
    },
    deleteEvent(record) {
      this.getHttpServices().getPermissionService()
        .post('roleLimits/deleteRoleByRoleId/' + record.roleId)
        .then(res => {
          this.$message.success('删除成功')
          this.$refs.table.refresh()
        }).catch((reason) => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style lang="less">
@import "./baseInfo";
</style>